import { useGetPayoutMethodsApiV1Suspense } from "@/api/__generated__/api.schema";
import { useWorkspaceId } from "@/hooks/auth/use-workspace";

export const usePayoutMethods = () => {
  const workspaceId = useWorkspaceId();
  const {
    data: {
      data: {
        item: { payoutMethods },
      },
    },
  } = useGetPayoutMethodsApiV1Suspense(workspaceId);

  return {
    data: {
      payoutMethods,
    },
  };
};
